export class StorageKeyConstants {
  static readonly ACCESS_TOKEN_KEY = 'access_token';
  static readonly REFRESH_TOKEN_KEY = 'refresh_token';
  static readonly ID_TOKEN_KEY = 'id_token';
  static readonly LANGUAGE_KEY = 'language';
  static readonly DEVICE_ID_KEY = 'device_id';
  static readonly ID_TOKEN_CLAIMS = 'id_token_claims_obj';
}
